// Executive scorecard tiles (approved HTML component: executive-scorecard).
import type { ReactNode } from 'react';
import type { Scorecard } from '../mockData.js';

export interface ExecutiveScorecardProps {
  cards: Scorecard[];
}

export function ExecutiveScorecard({ cards }: ExecutiveScorecardProps): ReactNode {
  return (
    <section className="scorecard-grid" data-component="executive-scorecard">
      {cards.map(card => (
        <article
          key={card.key}
          className="scorecard"
          role="button"
          tabIndex={0}
          aria-label={`View ${card.label.toLowerCase()} details`}
        >
          <span className="metric-label">{card.label}</span>
          <strong data-kpi={card.key}>{card.value}</strong>
          <span className="delta" data-delta={card.key}>
            {card.delta}
          </span>
          <small>{card.caption}</small>
          {card.target ? <span className="target">{card.target}</span> : null}
        </article>
      ))}
    </section>
  );
}
